import * as z from 'zod/v4';

import { drawNumberSchema } from '../draw/entry.js';
import { dateTimeSchema } from '../frameworks/entry.js';
import { productSchema } from '../product/entry.js';
import { wagerSchema } from './wager.js';
import { wagerIdSchema } from './wagerId.js';
import { wagerPropertiesSchema } from './wagerProperties.js';
import { wagerStatusSchema } from './wagerStatus.js';
import { windDivisionSchema } from './winDivision.js';

const drawInfoSchema = z.object({
  productId: productSchema,
  drawNumber: drawNumberSchema,
  time: dateTimeSchema,
});

const wagerInfoSchema = z
  .object({
    wagerId: wagerIdSchema,
    productId: productSchema,
    description: z.string(),
    // betAmount: currencySchema, // TODO: data is can be calculated by client selector
    // rowCount: z.number(), // TODO: value can be calculated by client selector
    // systemType: systemTypeEnum, // TODO: data is already available in coupon
    // Statuses
    // completed: z.boolean(),
    isGroup: z.boolean(),
    isFraction: z.boolean(),
    fractionHolderFractionCount: z.preprocess(
      (val) => (val === null || val === undefined ? val : Number(val)),
      z.number().nullish()
    ),
    // isCompetitionWager: z.boolean(),
    // isUserBoards: z.boolean(), //TODO: used for what prolonging wager, is it necessary?
    examined: z.boolean(), // TODO: rename to isExamined
    isLive: wagerStatusSchema,
    // hasJoker: z.boolean(), // TODO: used for sportkryss, should be renamed to addonBet?, data is already available as "sportkryss" in coupon
    // Dates
    completedOn: dateTimeSchema.nullish(),
    lastDrawDate: dateTimeSchema,
    regWagerTime: dateTimeSchema,
    cancelCloseTime: dateTimeSchema.nullish(),
    matchStartTime: dateTimeSchema.nullish(),
    // totalDrawCount: z.number(), // TODO: data is already available as "week" in coupon
    // completedDrawCount: z.number(),
    // addonTotalDrawCount: z.number(), // TODO: used for sportkryss (same as week)
    // addonCompletedDrawCount: z.number(), // TODO: used for sportkryss
    currentAddonDrawNumber: z.preprocess(
      (val) => (val === null || val === undefined ? val : Number(val)),
      drawNumberSchema.nullish()
    ),
    currentDrawNumber: z.preprocess(
      (val) => (val === null || val === undefined ? val : Number(val)),
      drawNumberSchema.nullish()
    ),
    // productVersion: z.unknown(),
    // subproductName: z.unknown(),
    // productName: z.unknown(),

    // extraDescription: z.unknown(),
    // isSystemWager: z.unknown(), // TODO: unused ?
    // isSyndicate: z.unknown(),
    // isSubscription: z.unknown(),
    // isReduceFreely: z.unknown(),
    // isLiveBet: z.unknown(),
    // isFutureWager: z.unknown(),
    // isWinningWager: z.unknown(),
    // packageName: z.unknown(),
    // winText: z.unknown(),
    // fractionHolderAmount: z.unknown(),
    // descriptionItems: z.unknown(),
    // refunds: z.unknown(),
    // couponCode: z.unknown(),
    // completedDrawNumbers: z.unknown(), // is it needed when we have completedDraws?
    // winAmount: currencySchema, // exists in windDivisionSchema
  })
  .transform(({ examined: isExamined, isLive: status, ...wagerInfo }) => {
    return { wagerInfo: { isExamined, status, ...wagerInfo } };
  });

export const playerWager = z
  .object({
    properties: wagerPropertiesSchema,
    wins: z.array(windDivisionSchema),
    completedDraws: z.array(drawInfoSchema),
    examinedDraws: z.array(drawInfoSchema),
    wager: wagerSchema,
  })
  .and(wagerInfoSchema)
  .transform(({ wager, properties, ...data }) => {
    const { marketplace, competition, registrationInfo } = properties;
    return {
      ...data,
      marketplace,
      competition,
      registrationInfo,
      coupon: wager,
    };
  });
